export default "__VITE_ASSET__CrnFA9w0__"